import React from "react";

/**
 * Absolutely positions a block at coordinates lifted straight from the approved PDF.
 *
 * The marketing pages are fixed compositions on a fixed page size (1056 x 816px, which
 * is 11 x 8.5in at 96dpi), so placing blocks at the design's own coordinates is both the
 * most faithful and the most reviewable approach - every number here can be checked
 * against the template. Text still flows normally inside each block.
 */
export default function Abs({x, y, w, h, className, style, children}) {
    return (
        <div
            className={`bov-abs${className ? ` ${className}` : ''}`}
            style={{
                left: `${x}px`,
                top: `${y}px`,
                ...(w == null ? {} : {width: `${w}px`}),
                ...(h == null ? {} : {height: `${h}px`}),
                ...style,
            }}
        >
            {children}
        </div>
    );
}
